import { useAuth0 } from '@auth0/auth0-react';
import { useEffect } from 'react';

import { HttpClient } from '../api/index.js';
import { identify } from '../utils/index.js';

const useInitialSetup = () => {
  const { isLoading, user = {}, getAccessTokenSilently } = useAuth0();
  useEffect(() => {
    HttpClient.createInstance(getAccessTokenSilently);
  }, []);

  // Identify the user in analytics
  useEffect(() => {
    if (!isLoading) {
      const userId = user!.sub;

      if (userId) {
        identify(userId);
      }
    }
  }, [isLoading, user]);

  return { isLoading };
};

export default useInitialSetup;
